import { Chart, registerables } from "chart.js";
import { useEffect, useRef } from "react";

Chart.register(...registerables);

const formatData = ({ data, backgroundColor, barThickness } = {}) => {
  return {
    labels: data?.labels,
    datasets: data?.datasets,
  };
};

const DoughnutChart = (props) => {
  const {
    data = [],
    height = 250,
    id = "doughnut-chart",
    barThickness = 12,
    borderRadius = 100,
    dataBgColor = "#FFB703",
  } = props;

  const chartRef = useRef(null);

  useEffect(() => {
    const createChart = (chartData) => {
      const ctx = document.getElementById(id)?.getContext("2d");
      chartRef.current = new Chart(ctx, {
        type: "doughnut",
        data: chartData,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const value = context.parsed;
                  return `${value}%`;
                }
              }
            }
          },
        },
      });
    };

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    createChart(
      formatData({ data, backgroundColor: dataBgColor, barThickness }),
    );

    return () => {
      chartRef.current.destroy();
    };
  }, [barThickness, borderRadius, data, dataBgColor, id, height]);

  return (
    <div className='w-full'>
      <canvas id={id} width='400' height={height}></canvas>
    </div>
  );
};

export default DoughnutChart;
